import cx from 'classnames'
import { SecurityStaticData } from '../../../store/securities/reducer'
import DepthOfMarket from '../../DepthOfMarket/Depth/DepthOfMarket'
import ExpandableComponent from '../../ExpandableComponent/ExpandableComponent'
import ExpandableSectionTitle from '../../ExpandableComponent/ExpandableSectionTitle'

import depthStyles from '../../DepthOfMarket/Depth/DepthOfMarket.module.scss'
import titleStyles from '../ModalSecurityInformationWrapper.module.scss'

interface Props {
  security: SecurityStaticData
}

const TitleComponent = (
  isExpanded: boolean,
  setExpanded: (expanded: boolean) => void
) => {
  return (
    <ExpandableSectionTitle
      isExpanded={isExpanded}
      setExpanded={setExpanded}
      className={titleStyles.securityInfoTitle}
    >
      Depth of Market
    </ExpandableSectionTitle>
  )
}

const LastLookDepth = ({ security }: Props) => {
  return (
    <ExpandableComponent title={TitleComponent} isInitiallyExpanded={false}>
      <DepthOfMarket
        security={security}
        callId={`lastlook-${security.id}`}
        className={cx(depthStyles.depthOfMarket, depthStyles.lastLookDepth)}
      />
    </ExpandableComponent>
  )
}

export default LastLookDepth
